export default __webpack_public_path__ + "static/media/Competitor.7ce55029.png";